import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ever-leaf-nyc-api.onrender.com';
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'everleaf_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Resolve image URLs: absolute http(s) stay as-is; relative /api/uploads get backend prefix
export const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;

  if (url.startsWith('/static/') || url.startsWith('static/')) {
    return url;
  }

  const cleanUrl = url.startsWith('/') ? url : `/${url}`;
  return `${BACKEND_URL}${cleanUrl}`;
};
// Public axios (no auth)
export const publicApi = axios.create({ baseURL: API });

// Authenticated axios for admin calls
export const authApi = axios.create({ baseURL: API });
authApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------- Public fetchers ----------
export const fetchContent = () => publicApi.get('/content').then((r) => r.data);
export const getCachedProjects = (all = false) => {
  try {
    const value = localStorage.getItem(all ? 'everleaf_projects_all' : 'everleaf_projects');
    return value ? JSON.parse(value) : [];
  } catch {
    return [];
  }
};

export const fetchProjects = (all = false) =>
  publicApi.get(`/projects${all ? '?all=true' : ''}`).then(r => {
    try {
      localStorage.setItem(
        all ? 'everleaf_projects_all' : 'everleaf_projects',
        JSON.stringify(r.data)
      );
    } catch {}
    return r.data;
  });
export const fetchReviews = (all = false) =>
  publicApi.get(`/reviews${all ? '?all=true' : ''}`).then((r) => r.data);
export const submitEstimate = (data) => publicApi.post('/estimates', data).then((r) => r.data);
export const submitReview = (data) => publicApi.post('/reviews', data).then((r) => r.data);

// ---------- Auth ----------
export const login = (username, password) =>
  publicApi.post('/auth/login', { username, password }).then((r) => r.data);
export const fetchMe = () => authApi.get('/auth/me').then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  authApi.post('/auth/change-password', { current_password, new_password }).then((r) => r.data);

// ---------- Admin: estimates ----------
export const adminListEstimates = () => authApi.get('/estimates').then((r) => r.data);
export const adminUpdateEstimate = (id, statusVal) =>
  authApi.patch(`/estimates/${id}`, { status: statusVal }).then((r) => r.data);

// ---------- Admin: content ----------
export const adminUpdateContent = (data) => authApi.put('/admin/content', data).then((r) => r.data);

// ---------- Admin: projects ----------
export const adminCreateProject = (data) => authApi.post('/admin/projects', data).then((r) => r.data);
export const adminUpdateProject = (id, data) =>
  authApi.put(`/admin/projects/${id}`, data).then((r) => r.data);
export const adminDeleteProject = (id) => authApi.delete(`/admin/projects/${id}`).then((r) => r.data);
export const adminReorderProjects = (ids) =>
  authApi.post('/admin/projects/reorder', { ids }).then((r) => r.data);

// ---------- Admin: reviews ----------
export const adminCreateReview = (data) => authApi.post('/admin/reviews', data).then((r) => r.data);
export const adminUpdateReview = (id, data) =>
  authApi.put(`/admin/reviews/${id}`, data).then((r) => r.data);
export const adminDeleteReview = (id) => authApi.delete(`/admin/reviews/${id}`).then((r) => r.data);

// ---------- Admin: upload ----------
export const adminUploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return authApi
    .post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data);
};
